<template>
    <div class="col-lg-4">
      <div class="relative hover-card">
        <div v-bind:style="'background-image: url(' + thumbnailSrc + ')'" class="product-card-image"></div>
        <div class="grey-backing-card">
          <h3 class="card-title">{{product.title}}</h3>
          <p v-if="product.type=='engine'">Engine Type: {{product.metadata.engine_type}}</p>
          <p>
            <strong>{{priceString}}</strong>
          </p>
          <p style="width: 100%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;opacity:.6">
            {{product.description}}</p>

          <div v-on:click="$emit('edit-product', product.id)" class="button-container space-top-small">
            <div class="standard-button d-flex flex-row">
              <div class="cart-left d-flex align-items-center">
                <p>Edit</p>
              </div>
              <div class="cart-right d-flex align-items-center justify-content-center">
                <PencilIcon :size="100" fillColor="rgb(255,255,255)" />
              </div>
            </div>
          </div>

          <div v-on:click="$emit('delete-product', product.id)" class="button-container space-top-small space-left">
            <div class="standard-button d-flex flex-row">
              <div class="cart-left d-flex align-items-center">
                <p>Delete</p>
              </div>
              <div class="cart-right d-flex align-items-center justify-content-center">
                <DeleteIcon :size="100" fillColor="rgb(255,255,255)" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
   import DeleteIcon from 'vue-material-design-icons/Delete.vue';
   import PencilIcon from 'vue-material-design-icons/Pencil.vue';
  export default {
    components:{
      PencilIcon,
      DeleteIcon
    },
    props: {
      product: {
        type: Object,
        default: function () {
          return {
            id: "",
            type: "Product Type",
            metadata: {},
            title: "Product Title",
            price: 5.0,
            description: "Product Description",
            status: "listed",
            media: [],
          };
        },
      },
    },
    computed: {
      priceString() {
        return this.product.price.toLocaleString(undefined, {
          style: "currency",
          currency: "USD",
        });
      },
      thumbnailSrc() {
        var id = "";
        if (typeof this.product.metadata.thumbnail != "undefined") {
          id = this.product.metadata.thumbnail;
        } else if (this.media.length != 0) {
          id = this.media[0].id;
        }
        return process.env.VUE_APP_API_URL + `/media/thumbnails/300/${id}.png`;
      },
    },
  };
</script>